// extracted by mini-css-extract-plugin
export default {"storiesPageContainer":"StoriesPage_storiesPageContainer__tsHQp","storiesMainHeading":"StoriesPage_storiesMainHeading__9RK43","storyContainer":"StoriesPage_storyContainer__bMxk5"};